import * as React from 'react';

import { singleton } from 'logic/singleton';
import type View from 'views/logic/views/View';

const ViewContext = React.createContext<View | undefined>(undefined);

export default singleton('contexts.SearchFiltersViewContext', () => ViewContext);
